import { Component, OnInit } from '@angular/core';
import { map, Observable } from 'rxjs';
import { isValidDate } from '../../helper/datehelper';
import { SearchService } from '../../store/search/search.service';
import { Domain, Filter, FilterExtended } from '../../store/search/types';

@Component({
  selector: 'app-search-bar-badge',
  templateUrl: './search-bar-badge.component.html',
  styleUrls: ['./search-bar-badge.component.scss'],
  standalone: false,
})
export class SearchBarBadgeComponent implements OnInit {
  activeFiltersExtended$: Observable<FilterExtended[]>;
  protected readonly isValidDate = isValidDate;

  constructor(private readonly searchService: SearchService) {
    this.activeFiltersExtended$ = this.searchService.getActiveFilters().pipe(
      map((filters) =>
        [...filters].sort((a, b) => this.getPriority(a) - this.getPriority(b)),
      ),
      map((filters) =>
        filters.map((filter) => {
          return {
            text: filter.text,
            tag: filter.tag,
            isReadOnly: filter.isReadOnly,
            name: filter.name,
            description: filter.description,
            canRemove:
              (filter.tag === 'Property' && !filter.isReadOnly) ||
              (filter.tag !== 'Property' && filter.tag !== 'Permanent'),
            domains: filter.domains,
          } as FilterExtended;
        }),
      ),
    );
  }

  ngOnInit(): void {}

  getPriority(filter: Filter): number {
    if (filter.tag === 'Permanent') return 0;
    if (filter.tag === 'Property' && filter.isReadOnly) return 1;
    return 2;
  }

  removeFilter(filterIndex: number) {
    this.searchService.removeActiveFilterByIndex(filterIndex);
    //activate if there is no smartFilter
    this.searchService.temporaryActivatePermanentFilters();
  }
}
